import React from 'react';
import { ArrowRight, CheckCircle2, Sparkles } from 'lucide-react';
import { money } from './shared';

/* "Where We Need to Lift Our Game" — ranked, data-driven, each with the action and the $ at stake. */
export default function LiftPanel({ cc }) {
  const lift = cc.lift || [];
  const wins = cc.wins || [];
  return (
    <section className="gpj-panel" data-testid="gpc-lift">
      <div className="gpj-panel-h">
        <h2>Where we need to lift our game</h2>
        <p>{lift.length ? `${lift.length} issue${lift.length === 1 ? '' : 's'} ranked by impact on target` : 'Nothing is holding the month back right now'}</p>
      </div>
      {lift.length === 0 ? (
        <div className="gpf-callout green" data-testid="gpc-lift-empty"><Sparkles className="w-4 h-4" /><span>Every tracked line is on pace. Keep lodging to build a buffer.</span></div>
      ) : (
        <div className="gpc-lift">
          {lift.map((x, i) => (
            <article className={`gpc-li ${x.severity}`} style={{ animationDelay: `${i * 70}ms` }} key={x.key} data-testid={`gpc-lift-${x.key}`}>
              <span className="n">{x.priority}</span>
              <div>
                <b>{x.title}</b>
                <p>{x.detail}</p>
                <div className="act"><ArrowRight /><span>{x.action}</span></div>
              </div>
              <div className="imp"><strong>{money(x.impact)}</strong><small>{x.impact_label}</small></div>
            </article>
          ))}
        </div>
      )}
      {wins.length > 0 && (
        <div className="gpc-wins" data-testid="gpc-wins">
          {wins.map((w) => <span className="gpc-win" key={w.key} data-testid={`gpc-win-${w.key}`}><CheckCircle2 /> {w.title} <small>· {w.detail}</small></span>)}
        </div>
      )}
    </section>
  );
}
